import { client, TOKEN_KEY, USER_KEY } from "../services";

// "View as": a Super Admin opens the panel signed in as a store owner or franchise partner (POST /admin/view-as).
// The Super Admin's own session is kept under RETURN_KEY so "Back to my account" can restore it. Both switches
// reload the panel, so nothing loaded for one account is shown to the other.
const RETURN_KEY = "oz_admin_return";

const read = () => {
  try {
    return JSON.parse(localStorage.getItem(RETURN_KEY));
  } catch {
    return null;
  }
};

// The Super Admin who is viewing, or null
export const viewingAsBy = () => {
  const saved = read();
  return saved && saved.token && saved.user ? saved.user : null;
};

export async function startViewAs(userId) {
  const { data } = await client.post(`/admin/view-as/${userId}`);
  localStorage.setItem(RETURN_KEY, JSON.stringify({ token: localStorage.getItem(TOKEN_KEY), user: JSON.parse(localStorage.getItem(USER_KEY)) }));
  localStorage.setItem(TOKEN_KEY, data.token);
  localStorage.setItem(USER_KEY, JSON.stringify(data.user));
  window.location.assign("/admin");
}

export function returnToMyAccount() {
  const saved = read();
  localStorage.removeItem(RETURN_KEY);
  if (saved && saved.token) {
    localStorage.setItem(TOKEN_KEY, saved.token);
    localStorage.setItem(USER_KEY, JSON.stringify(saved.user));
  } else {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(USER_KEY);
  }
  window.location.assign("/admin");
}
